export enum Languages {
    he = 'he',
    en = 'en',
}